import PageLayout from '../../Containers/PageLayout';
import CreateStudio from './CreateStudio';

interface Props {
  page: string;
}

const StudioManagement = (props: Props) => {
  const { page } = props;
  return (
    <PageLayout>
      <div>
        {page === 'CreateStudio' || page === 'UpdateStudio' ? (
          <CreateStudio />
        ) : null}
      </div>
    </PageLayout>
  );
};

export default StudioManagement;
